/* Stallion Keys - when an option change lands on a missing/sold-out combination,
   move the other option(s) to the closest in-stock variant with the clicked value. */
(function () {
  var radios = function () {
    return [].slice.call(document.querySelectorAll('input[type=radio][name*="-option"]'));
  };
  if (!radios().length || location.pathname.indexOf('/products/') === -1) return;

  var variants = null;
  var handle = location.pathname.split('/products/')[1].split('/')[0];
  fetch('/products/' + handle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (p) { variants = p.variants; });

  var groups = function () {
    var g = {};
    radios().forEach(function (r) { (g[r.name] = g[r.name] || []).push(r); });
    return Object.keys(g).map(function (k) { return g[k]; });
  };
  var urlVariant = function () {
    var m = location.search.match(/[?&]variant=(\d+)/); return m ? +m[1] : null;
  };
  var apply = function (pick, pos) {
    var gs = groups(), last = null;
    pick.options.forEach(function (o, i) {
      if (i === pos) return;
      var r = gs[i] && gs[i].find(function (x) { return x.value === o; });
      if (r) { r.checked = true; last = r; }
    });
    if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
  };

  var busy = false;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (busy || !variants || !t.matches('input[type=radio][name*="-option"]')) return;
    var pos = groups().findIndex(function (g) { return g.some(function (r) { return r.name === t.name; }); });
    var val = t.value;

    // let the theme finish its own update for the click first
    setTimeout(function () {
      var sel = groups().map(function (g) { var c = g.find(function (r) { return r.checked; }); return c && c.value; });
      var cur = variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
      if (cur && cur.available) return;

      var score = function (v) { return v.options.filter(function (o, i) { return o === sel[i]; }).length; };
      var pick = variants
        .filter(function (v) { return v.available && v.options[pos] === val; })
        .sort(function (a, b) { return score(b) - score(a); })[0];
      if (!pick) return;

      busy = true;
      apply(pick, pos);
      // a slow theme update can land after ours - re-apply until the page shows the picked variant
      var tries = 0;
      var check = setInterval(function () {
        tries++;
        if (urlVariant() === pick.id || tries > 6) { clearInterval(check); busy = false; return; }
        apply(pick, pos);
      }, 700);
    }, 600);
  }, true);
})();
